import type { FormTextareaProps } from '../types';
import type { FieldValues } from 'react-hook-form';

import { Textarea } from '@/components/Textarea';

import { FormFieldShell } from '../FormFieldShell';

export const FormTextarea = <TFieldValues extends FieldValues = FieldValues>(
  props: FormTextareaProps<TFieldValues>,
) => {
  const {
    name,
    label,
    hint,
    description,
    isRequired,
    placeholder,
    rows,
    textareaProps,
  } = props;

  return (
    <FormFieldShell
      name={name}
      description={description}
      render={({ field, fieldState, fieldId }) => (
        <Textarea
          {...field}
          value={field.value || ''}
          id={fieldId}
          label={label}
          aria-label={label}
          isRequired={isRequired}
          hint={hint}
          placeholder={placeholder ?? label}
          rows={rows}
          aria-invalid={fieldState.invalid}
          {...textareaProps}
        />
      )}
    />
  );
};
